<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-page-header slds-has-bottom-magnet">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-avatar slds-avatar_medium">
            <img alt="Capture Time" src="/assets/accorto/perDiem-100.svg">
          </span>
        </div>
        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span class="slds-page-header__title slds-truncate">Reisekosten Pauschalen</span>
              </h1>
            </div>
          </div>
          <p class="slds-page-header__name-meta"></p>
        </div>
      </div>

    </div>
    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <ul class="slds-button-group-list">
            <li>
              <button (click)="onNew()"
                      class="slds-button slds-button_neutral"
                      id="pdd-new"
                      title="New Per Diem Trip">
                <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#new"></use>
                </svg>
                New
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- status -->
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-meta">
      <acc-status-line [error]="error" [message]="message"></acc-status-line>
    </div>
  </div>

</header>

<section class="slds-is-relative">

  <article class="slds-card slds-p-around_small slds-m-top_small" id="trip">
    <h1 class="slds-text-heading_medium">Trip</h1>

    <div class="slds-grid slds-wrap slds-form_stacked">

      <div class="slds-col slds-size_1-of-1 slds-medium-size_1-of-3">
        <acc-form-date [ff]="tripStartDate"
                       [fm]="tripFm"
                       theId="startDate">
        </acc-form-date>
      </div>
      <div class="slds-col slds-size_1-of-1 slds-medium-size_1-of-3">
        <acc-form-date [ff]="tripEndDate"
                       [fm]="tripFm"
                       theId="endDate">
        </acc-form-date>
      </div>
      <div class="slds-col slds-size_1-of-1 slds-medium-size_1-of-3">
        <acc-form-search [ff]="tripDestination"
                         [fm]="tripFm"
                         [options]="tripOptions"
                         theId="destination">
        </acc-form-search>
      </div>
    </div>

    <button (click)="onTripSubmit()"
            [disabled]="tripFm.formGroup.invalid"
            id="pdd-calc"
            class="slds-button slds-button_neutral slds-m-top_small">Kalkulieren
    </button>

    <div *ngIf="isDebug()" class="slds-m-top_small">
      <small>
        <p>
          Form Status: {{ tripFm.formGroup.status }}
        </p>
        <p>
          Form Values: {{ tripFm.formGroup.value | json }}
        </p>
      </small>
    </div>
  </article>


  <article *ngIf="items.length > 0"
           [formGroup]="diemForm"
           class="slds-card slds-p-around_small slds-m-top_small"
           id="per-diems">
    <div class="slds-scrollable">
      <table class="slds-table slds-table_bordered" role="grid">
        <thead>
        <tr class="slds-line-height_reset">
          <th scope="col" title="Reisetag">Datum</th>
          <th scope="col" title="Reiseziel">Ziel</th>
          <th scope="col" title="Verpflegungspauschale">Verpflegung</th>
          <th scope="col" title="Reduzierte Verpflegungspauschale">8-24</th>
          <th scope="col" title="Abzug erhaltenes Frühstück">Frühstück</th>
          <th scope="col" title="Abzug erhaltenes Mittagessen">Mittag</th>
          <th scope="col" title="Abzug erhaltenes Abendessen">Abend</th>
          <th scope="col" title="Übernachtungspauschale">Übernachtung</th>
          <th scope="col" title="Reise Beschreibung">Beschreibung</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of items; index as i;"
            class="slds-hint-parent"
            formArrayName="days">
          <ng-container [formGroupName]="i">
            <td title="Reisetag">{{item.dateMs ? item.dateMs : '' | dateMs }}</td>
            <td title="Reiseziel">{{item.destination}}</td>
            <td title="Verpflegungspauschale">
              <label><input formControlName="meals" type="checkbox"/>
                {{item.rateMeals | number:'1.2-2'}}</label>
            </td>
            <td title="Reuzierte Verpflegungspauschale">
              <label><input formControlName="meals2" type="checkbox"/>
                {{item.rateMeals2 | number:'1.2-2'}}</label>
            </td>
            <td title="Abzug erhaltenes Frühstück">
              <label><input formControlName="breakfast" type="checkbox"/>
                {{item.rateBreakfast | number:'1.2-2'}}</label>
            </td>
            <td title="Abzug erhaltenes Mittagessen">
              <label><input formControlName="lunch" type="checkbox"/>
                {{item.rateLunch | number:'1.2-2'}}</label>
            </td>
            <td title="Abzug erhaltenes Abendessen">
              <label><input formControlName="dinner" type="checkbox"/>
                {{item.rateDinner | number:'1.2-2'}}</label>
            </td>
            <td title="Übernachtungspauschale">
              <label><input formControlName="lodging" type="checkbox"/>
                {{item.rateLodging | number:'1.2-2'}}</label>
            </td>
            <td>
              <input formControlName="description" type="text"/>
            </td>
          </ng-container>
        </tr>
        </tbody>
        <tfoot>
        <tr style="background-color: #fafaf9">
          <th>Total</th>
          <th></th>
          <th>{{ totalMeals | number:'1.2-2' }}</th>
          <th>{{ totalMeals2 | number:'1.2-2' }}</th>
          <th>{{ totalBreakfast | number:'1.2-2' }}</th>
          <th>{{ totalLunch | number:'1.2-2' }}</th>
          <th>{{ totalDinner | number:'1.2-2' }}</th>
          <th>{{ totalLodging | number:'1.2-2' }}</th>
          <th>= {{ totals | number:'1.2-2' }}</th>
        </tr>
        </tfoot>
      </table>
    </div>

    <acc-form #theForm
              [record]="record"
              [showFooter]="false"
              [ui]="ui">
    </acc-form>

    <button (click)="onDiemSubmit()"
            [disabled]="!totals"
            id="pdd-create"
            class="slds-button slds-button_neutral slds-m-top_small">Create Per Diems
    </button>

    <div *ngIf="isDebug()" class="slds-m-top_small">
      <small>
        <p>
          Form Status: {{ diemForm.status }}
        </p>
        <p>
          Form Values: {{ diemForm.value | json }}
        </p>
        <p>
          Items: {{ items | json }}
        </p>
      </small>
    </div>
  </article>


  <acc-spinner *ngIf="busy"></acc-spinner>
</section>
